"use client";

import { usePolimorphicLinkAttributes } from "@faire/slate/private/button/usePolimorphicLinkAttributes";
import { ILinkWebProps } from "@faire/slate/private/link/types";
import { LocationDescriptor } from "history";
import React from "react";

type IProps = ILinkWebProps & {
  className?: string;
};

export const LinkAsPolymorphicLink = ({
  className,
  linkTo,
  ...props
}: IProps) => {
  const { as: Component, linkProps } = usePolimorphicLinkAttributes({
    ...props,
    linkTo,
  });
  const to = (
    "to" in linkProps ? linkProps.to : undefined
  ) as LocationDescriptor;
  return <Component {...props} {...linkProps} to={to} className={className} />;
};
